// extracted by mini-css-extract-plugin
export default {"container":"style_container__vmAF7","background":"style_background__1hjuB","svg":"style_svg__klAlC"};